import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import {
  isRefundReturnFromModel,
  validateIsRefundReturnCondition,
  type IsRefundReturnState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_REFUND_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsRefundReturnState>>,
): ConditionType<IsRefundReturnState, ModelCondition.IsRefundReturn> => ({
  name: "Requested refund on return",
  description() {
    return "Requested refund on return.";
  },
  Details(props: ConditionTypeDetailsProps<IsRefundReturnState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return isRefundReturnFromModel(model);
  },
  toModel(state) {
    return { type: ModelCondition.IS_REFUND_RETURN, orderCount: state };
  },
  valid(state) {
    return validateIsRefundReturnCondition(state).valid;
  },
});

export { type IsRefundReturnState } from "@redotech/redo-model/return-flow/condition-validate";
